import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('detailsViewCardApplicationList');

    return {
        noApplications: t('noApplications')
    };
};

export default useTranslation;
